import { connect } from 'react-redux';
import { loadTranslations } from '../store/translationSlice';

const mapStateToProps = (state) => ({
	translations: state.translation.translations,
	currentLanguage: state.translation.currentLanguage,
});

const mapDispatchToProps = (dispatch) => ({
	changeLanguage: (language) => 
	dispatch(loadTranslations(language)),
});

const t = (translations, key) => {
	const keys = key.split('.');
	let value = translations;
	
	for (const k of keys) {
		if (value[k] === undefined) {
			return ""; // Return empty string if not translation found
		}
		value = value[k];
	}
	return value;
};

export const withTranslation = (WrappedComponent) => {
	return connect(mapStateToProps, mapDispatchToProps)((props) => {
		const translate = (key) => t(props.translations, key);
		return ( <WrappedComponent {...props} t={translate} />);
	});
};
